export default __webpack_public_path__ + "static/visited-after-2b74dc42ac7c1cf74fa184382f43b142.png";